import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Policy from './Pages/Policy/Policy';
import Home from './Pages/Home/Home';

export default function App() {
  return (
    <div className="App">
        <div className="wrapper">
          <Header />

            <main className="main">
              <Routes>
                <Route path="/" element={<Home />}/>
                <Route path='/privacy-policy' element={<Policy />}/>

              </Routes>
            </main>

          <Footer />
        </div>
    </div>
  );
}

